import { render, staticRenderFns } from "./forget-pass.vue?vue&type=template&id=048989e8&scoped=true&"
import script from "./forget-pass.vue?vue&type=script&lang=js&"
export * from "./forget-pass.vue?vue&type=script&lang=js&"
import style0 from "./forget-pass.vue?vue&type=style&index=0&id=048989e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048989e8",
  null
  
)

export default component.exports